import {
    AnimationLoadingBaseController,
    IAnimationControllerConfiguration,
    ILoadingBaseController,
    Inject,
} from '@denishussar/html5-game-engine';
import { Graphics } from 'pixi.js';
import { AnimationContents } from '../../AnimationContents';
import { GameModel } from '../Models/GameModel';

export interface ILoaderGameControllerOptions {
    test: string;
}

export class LoaderGameController extends AnimationLoadingBaseController implements ILoadingBaseController {
    public $model: GameModel;

    private _width: number = 0;
    private _height: number = 0;
    private _scale: number = 1;

    private _isSpinner: boolean = false;
    private _graphics: Graphics = null;

    private _mask: Graphics;
    private _dom: HTMLElement;
    private _progressScale: number = 0.74;
    private _progress: number = 0;

    public constructor(@Inject private _options: ILoaderGameControllerOptions) {
        super('LoaderGameController');

        this._dom = document.querySelector('#gameCanvas').parentElement;
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.PRELOADER_SCREEN_JSON,
            libraryName: 'preloader_screen',
        };
    }

    protected onInitialize(): void {
    }

    protected onUpdate(frameRate: number): void {
        if (this._isSpinner) {
            this.setRotationByQuery('container.spinner', this.getDisplayObjectByQuery('container.spinner')[0].rotation += frameRate * 10);

            if (this._graphics) { // mb cpu overhead, the cacheAsBitmap is possible
                const w = this._width / this._scale * 5;
                const h = this._height / this._scale * 5;

                this._graphics.clear();
                this._graphics.beginFill(0x000000, 0.1);
                this._graphics.drawRect(-w / 2, -h / 2, w, h);
                this._graphics.endFill();
            }

        } else {
            if (!this._isSpinner) {
                const sizeW = this._width / this._scale;
                const sizeH = this._height / this._scale;
    
                const containerScale = Math.min(sizeW / 1920, sizeH / 1440);
                const bgScale = Math.max(sizeW / 3000, sizeH / 3000);
                if (this._mask) {
                    this._mask.x = (this._width - 577 * containerScale * this._scale) / 2;
                    this._progressScale = containerScale * this._scale;
                    this._mask.scale.x = this._progress * this._progressScale;
                    this._mask.scale.y = this._progressScale;
                }
    
                this.scaleX = containerScale;
                this.scaleY = containerScale;
                
                const bg = this.getDisplayObjectByQuery('bg')[0];
                bg.scale.x = bgScale / containerScale;
                bg.scale.y = bgScale / containerScale;
                //@ts-ignore
                bg.anchor.x = 0.5;
                //@ts-ignore
                bg.anchor.y = 0.5;
                bg.x = 0;
            }
        }
    }

    public onLoadingProgress(progress: number) {
        if (!this._isSpinner) {
            this._progress = progress;
            this._mask.scale.x = this._progressScale * this._progress;
        }
    }

    public onHide(): void {
        if (this._graphics) {
            this.display.removeChild(this._graphics);
            this._graphics = null;
        }

        if (this._mask) {
            this._mask.scale.x = 1;
            this._mask.scale.y = 1;
            this._mask.x = 0;
            this._mask.clear();
        }

        this.scaleX = 1;
        this.scaleY = 1;
    }

    public onShow(): void {
        this._isSpinner = this.$model.gameIsLoading;

        this.gotoAndStop(this._isSpinner ? 1 : 0);

        if (this._isSpinner) {
            if (!this._graphics) {
                this._graphics = new Graphics();
                this._graphics.interactive = false;
                this.display.addChildAt(this._graphics, 0);
            }

        } else {
            if (!this._mask) {
                this._mask = new Graphics();
            }

            this._mask.scale.x = 1;
            this._mask.scale.y = 1;
            this._mask.x = 0;

            this._mask.clear();
            this._mask.beginFill(0xffffff);
            this._mask.drawRect(0, 0, 577, 10000);
            this._mask.endFill();

            // @ts-ignore
            const progressBar = this.getDisplayObjectByQuery('container')[0].children[2].children[1].children[0] as Sprite;
            progressBar.mask = this._mask;
            const bg = this.getDisplayObjectByQuery('bg')[0];
            //@ts-ignore
            bg.anchor.x = 0.5;
            //@ts-ignore
            bg.anchor.y = 0.5;
        }
    }

    protected onResize(width: number, height: number, scale: number) {
        this._width = width;
        this._height = height;
        this._scale = scale;
        if (!this._isSpinner) {
            const sizeW = this._width / this._scale;
            const sizeH = this._height / this._scale;

            const containerScale = Math.min(sizeW / 1920, sizeH / 1440);
            const bgScale = Math.max(sizeW / 3000, sizeH / 3000);
            if (this._mask) {
                this._mask.x = (this._width - 577 * containerScale * this._scale) / 2;
                this._progressScale = containerScale * this._scale;
                this._mask.scale.x = this._progress * this._progressScale;
                this._mask.scale.y = this._progressScale;
            }

            this.scaleX = containerScale;
            this.scaleY = containerScale;
            
            const bg = this.getDisplayObjectByQuery('bg')[0];
            bg.scale.x = bgScale / containerScale;
            bg.scale.y = bgScale / containerScale;
            //@ts-ignore
            bg.anchor.x = 0.5;
            //@ts-ignore
            bg.anchor.y = 0.5;
            bg.x = 0;
        }

    }
}
